// extracted by mini-css-extract-plugin
module.exports = {"slider__footer":"Slider_slider__footer__NRNl7"};